module.exports = __webpack_public_path__ + "images/volkswagen0862893de84b1068ce4f413bbeec0f62.png";